<template>
  <el-main class="iDalgo-Template-New">
    <el-row type="flex" class="card align-center">
      <el-col :span="20">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ name: 'templates' }">{{ $t('iDalgoLists.breadcrumb') }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ $t('iDalgoListNew.breadcrumb') }}</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
      <el-col :span="4" class="flex-end"><el-button @click="goBack" type="default">{{ $t('actions.cancelButton') }}</el-button></el-col>
    </el-row>
    <div class="mrg-20"></div>
    <el-row type="flex" class="card">
      <el-col class="form">
        <el-form :model="form" :rules="rules" ref="form">
          <el-form-item prop="name">
            <el-input v-model="form.name" :placeholder="$t('iDalgoListNew.form.nameField')"></el-input>
          </el-form-item>
          <el-form-item prop="size">
            <el-input v-model.number="form.size" :placeholder="$t('iDalgoListNew.form.sizeField')">
              <el-tooltip slot="suffix" effect="dark" :content="$t('iDalgoListNew.form.sizeHelp')" placement="right">
                <i class="el-icon-info"></i>
              </el-tooltip>
            </el-input>
          </el-form-item>
          <i-dalgo-button @click="submitForm" :loading="isLoading" style="width: 100%">{{ $t('actions.newButton') }}</i-dalgo-button>
        </el-form>
      </el-col>
    </el-row>
  </el-main>
</template>

<script>
import iDalgoButton from '@/components/iDalgo-Button'

export default {
  name: 'iDalgo-Template-New',
  components: {
    iDalgoButton
  },
  computed: {
    isLoading: {
      get () { return this.$store.getters['templates/isLoading'] },
      set (value) { this.$store.commit('templates/LOADING_UPDATED', value) }
    }
  },
  data () {
    return {
      form: {
        name: '',
        size: null
      },
      rules: {
        name: [
          { required: true, message: this.$t('iDalgoListNew.formRules.name.requiredMessage'), trigger: 'blur' },
          { min: 3, max: 255, message: this.$t('iDalgoListNew.formRules.name.sizeMessage'), trigger: 'blur' }
        ],
        size: [
          { required: true, message: this.$t('iDalgoListNew.formRules.size.requiredMessage'), trigger: 'blur' },
          { type: 'number', min: 1, max: 50, message: this.$t('iDalgoListNew.formRules.size.sizeMessage'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    async submitForm () {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          this.isLoading = true
          // We save data
          try {
            // Add one default section in template
            this.form._sections = [
              {
                id: '_' + Math.random().toString(36).substr(2, 9),
                name: this.$t('iDalgoListNew.defaultSectionName'),
                size: 1,
                _players: []
              }
            ]
            let id = await this.$store.dispatch('templates/createTemplate', this.form)
            // await this.$store.dispatch('templates/createTemplate', { templateId, name: this.$t('iDalgoListNew.defaultSectionName'), size: this.form.size })
            this.isLoading = false
            this.$notify({
              title: this.$t('iDalgoListNew.createNotification.successTitle'),
              message: this.$t('iDalgoListNew.createNotification.successMessage'),
              type: 'success'
            })
            this.$router.push({ name: 'editTemplate', params: { id } })
          } catch (e) {
            this.$notify.error({
              title: this.$t('iDalgoListNew.createNotification.errorTitle'),
              message: this.$t('iDalgoListNew.createNotification.errorMessage')
            })
            throw e
          }
        } else {
          return false
        }
      })
    },
    goBack () {
      this.$router.go(-1)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.form {
  justify-content: center;
  padding: 26px 0;

  .card {
    padding: $default_padding;
    margin: auto;
  }
}

.el-form {
  display: flex;
  flex-flow: column;
  align-items: center;
  width: 300px;
  padding: $default_padding * 2 0;

  & > * {
    margin: $default_padding / 2;
    width: 100%;
    transition: all 0.2s;
  }

  & > .is-error {
    margin-bottom: $default_padding;
  }

  &:last-child {
    margin-bottom: 0;
  }

}
</style>

<style lang="scss">
.iDalgo-Template-New {
  .form {
    .el-input {
      font-family: 'robotobold';
      font-size: 32px;
      input {
        color: $color1;
        border: none;
        padding: 0;

        &::placeholder {
          color: $text-gray;
        }
      }
    }

    .el-checkbox__label {
      font-size: 16px;
      color: $color1;
      font-family: 'robotoregular';
    }

    .el-button {
      width: 100%;
    }

    .el-icon-info {
      font-size: 16px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/iDalgo-Template-New.vue